import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import * as Yup from "yup";
import { APIURL, APIURLCOT } from "../../../Config";
import { toast } from "react-toastify";
import moment from "moment";
import { DownloadTableExcel } from "react-export-table-to-excel";
import Pagination from "../../Pagination/Pagination";
import SweetAlert from "react-bootstrap-sweetalert";
export default function LeadsCT() {
  const emailid = localStorage.getItem("emailId");
  const [width, setWidth] = React.useState(window.innerWidth < 768);
  console.log("width::: ", width);

  const [searchInput, setSearchInput] = useState("");
  const [keyName, setKeyName] = useState("mobile");
  const leadsTB = React.useRef(null);
  const token = localStorage.getItem("token");
  const [activeTab, setActiveTab] = useState("leads");
  const [isLoader, setIsLoader] = useState(false);
  const [leadsEdit, SetLeadsEdit] = useState(false);
  const [editValue, setEditValue] = useState("");
  const [leads, SetLeads] = useState([]);
  const [showPrePage, setShowPrePage] = useState(100);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPrePage,
  });
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    if (activeTab === "leads") {
      Getlead();
    }
  }, [activeTab]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const Getlead = () => {
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/corporate/getlead`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        if (response?.data == "No lead exists.") {
          SetLeads([]);
        } else {
          SetLeads(response?.data);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const deleteLead = (pno) => {
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/deletelead`, {
        method: "POST",
        data: {
          mobile: pno,
        },
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        toast.success(response.data);
        Getlead();
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  return (
    <div className={width ? "" : "p-3"}>
      <div>
        <ul className="nav nav-tabs-CT" id="myTabs" role="tablist">
          <li
            className={width ? "nav-item mt-2" : "nav-item"}
            role="presentation"
          >
            <button
              className={`nav-link  tab-item ${
                activeTab === "leads" ? "active" : ""
              }`}
              id="leads-tab"
              data-bs-toggle="tab"
              data-bs-target="#leads"
              type="button"
              role="tab"
              aria-controls="leads"
              aria-selected={activeTab === "leads"}
              onClick={() => handleTabClick("leads")}
            >
              Leads
            </button>
          </li>
        </ul>
        <div
          className={width ? "tab-content mt-1" : "tab-content mt-3"}
          id="myTabsContent"
        >
          <div
            className="tab-pane fade show active"
            id="leads"
            role="tabpanel"
            aria-labelledby="leads-tab"
          >
            <div className="pt-3">
              <div className="card">
                <div className={width ? "p-2" : "p-3 pt-4"}>
                  <div className="d-flex">
                    <DownloadTableExcel
                      filename="LeadsCT"
                      sheet="users"
                      currentTableRef={leadsTB.current}
                    >
                      <button
                        className="btn btn-success border"
                        style={{
                          width: "120px",
                          backgroundColor: "black",
                        }}
                      >
                        {" "}
                        Download{" "}
                      </button>
                    </DownloadTableExcel>
                  </div>
                  {isLoader ? (
                    <div className="d-flex justify-content-center">
                      <div
                        className="spinner-border text-success"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive mt-3">
                      <table className="table table-striped" ref={leadsTB}>
                        <thead>
                          <tr>
                            <th
                              style={{ textAlign: "center" }}
                              className="text-nowrap"
                            >
                              Sr. No
                            </th>
                            <th
                              style={{ textAlign: "center" }}
                              className="text-nowrap"
                            >
                              Client Name
                            </th>

                            <th
                              style={{ textAlign: "center" }}
                              className="text-nowrap"
                            >
                              Mobile No.
                            </th>
                            <th
                              style={{ textAlign: "center" }}
                              className="text-nowrap"
                            >
                              Current Status
                            </th>
                            {/* <th
                              style={{ textAlign: "center" }}
                              className="text-nowrap"
                            >
                              Customer Type
                            </th> */}
                            {/* <th
                              style={{ textAlign: "center" }}
                              className="text-nowrap"
                            >
                              Product Type
                            </th> */}
                            {/* <th
                              style={{ textAlign: "center" }}
                              className="text-nowrap"
                            >
                              Limit Assign
                            </th>
                            <th
                              style={{ textAlign: "center" }}
                              className="text-nowrap"
                            >
                              Limit Used
                            </th> */}
                            <th
                              style={{ textAlign: "center" }}
                              className="text-nowrap"
                            >
                              Branch
                            </th>
                            <th
                              style={{ textAlign: "center" }}
                              className="text-nowrap"
                            >
                              Login Date
                            </th>
                            <th
                              style={{ textAlign: "center" }}
                              className="text-nowrap"
                            >
                              Time
                            </th>
                            {/* <th className="text-nowrap">Lead From</th> */}

                            {/*  <th className="text-nowrap">Employer name</th>
                              <th className="text-nowrap">Contact name</th>
                              <th className="text-nowrap">Mobile</th>
                              <th className="text-nowrap">No of employees</th>
                              <th className="text-nowrap">
                                Set up (Custom HR)
                              </th>
                              <th className="text-nowrap">Funding</th>
                             <th className="text-nowrap">Type</th>
                             
                              <th
                                className="text-nowrap"
                                style={{ color: "red" }}
                              >
                                Lead marked Closed (no good to us)
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ color: "orange" }}
                              >
                                Lead marked as Non Assured
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ color: "green" }}
                              >
                                Lead marked as Assured Category
                              </th>
                              <th className="text-nowrap">Status</th>
                              <th className="text-nowrap">Remark</th> */}
                            <th
                              className="text-nowrap"
                              style={{
                                textAlign: "center",
                                width: "100px",
                              }}
                            >
                              Delete
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {leads && leads.length > 0 ? (
                            leads.map((item, i) => (
                              <tr key={i}>
                                <td style={{ textAlign: "center" }}>
                                  {i + 1 + pagination.start}
                                </td>
                                <td>{item.customerName}</td>
                                <td style={{ textAlign: "center" }}>
                                  {item.mobileNo}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item?.currentstatus || "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item?.branchName || "-"}
                                </td>

                                <td
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  {moment(item.approvedDate).format(
                                    "DD-MM-YYYY"
                                  )}
                                </td>
                                <td
                                  style={{ textAlign: "center" }}
                                  className="text-nowrap"
                                >
                                  {moment(item.approvedDate).format(
                                    "HH:mm:ss a"
                                  )}
                                </td>

                                <td className="text-nowrap">
                                  <button
                                    className="btn btn-danger"
                                    style={{ width: "100px" }}
                                    onClick={() => deleteLead(item.mobileNo)}
                                  >
                                    Delete
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" style={{ textAlign: "center" }}>
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
